import './index.scss'
import { useEffect, useState } from 'react'
import AnimatedLetters from '../AnimatedLetters'
import Loader from 'react-loaders'

const Experience = () => {
    const [letterClass, setLetterClass] = useState('text-animate')

    useEffect(() => {
        setTimeout(() => {
        setLetterClass('text-animate-hover')
        }, 3000)
    }, [])


    return (
        <>
        <div className='container experience-page'>
        <div className="text-zone">
            <h1>
                <AnimatedLetters
                    letterClass={letterClass}
                    strArray={['W', 'o', 'r', 'k', ' ', 'e', 'x', 'p', 'e', 'r', 'i', 'e', 'n', 'c', 'e']}
                    idx={15}
                />
            </h1>

            <div className="row company-section">
                <div className="column company-card">
                    <div className="company-name">
                        <a href="https://www.oracle.com/" target="_blank" rel="noreferrer">Oracle</a>
                    </div>

                    <div className="position-name">
                        Intern - Server Technology<span className="date">05/2022 - 07/2022</span>
                    </div>

                    <div className="work-description">
                        Worked as summer intern on the project "JSON BOV Performance Monitoring with Extended YCSB" in which I generated metrics for the database, which will serve as a benchmark in the market. 
                    </div>

                    <a href="https://drive.google.com/file/d/1oJq5S-ZQv4DOA14LuHLoj3HQOBVtvLSe/view?usp=sharing" target="_blank" rel="noreferrer" className="card-button">Certificate</a>
                </div>
                 
                <div className="column company-card">
                    <div className="company-name">
                        <a href="https://bugsmirror.com/" target="_blank" rel="noreferrer">Bugsmirror</a>
                    </div>

                    <div className="position-name">
                        Software Developer Intern<span className="date">05/2021 - 07/2021</span>
                    </div>

                    <div className="work-description">
                        Led the front-end development team and developed an internal application which is currently live and is used by the company to track the progress of the employees. <br />
                        Took the responsibility of integrating the front-end application with the back-end. 
                    </div>

                    <a href="https://drive.google.com/file/d/15dAzJCPSkoRchDaOo2v3oUM77b7ZuYVj/view?usp=sharing" target="_blank" rel="noreferrer" className="card-button">Certificate</a>
                    
                </div>
            </div>

        </div>


            <Loader type="pacman" />
        </div>
        </>
    )

}

export default Experience